import React from 'react';
import { FadeIn } from './FadeIn';
import PersonIcon from '@mui/icons-material/Person';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import WorkIcon from '@mui/icons-material/Work';
export function TargetSection() {
  const targets = [{
    icon: <PersonIcon sx={{
      fontSize: {
        xs: 28,
        md: 40
      }
    }} className="text-[#FF9F43]" data-id="element-134" />,
    text: 'Si vivís solo y te da pereza cocinar para uno.'
  }, {
    icon: <FamilyRestroomIcon sx={{
      fontSize: {
        xs: 28,
        md: 40
      }
    }} className="text-[#FF9F43]" data-id="element-135" />,
    text: 'Si sos madre/padre y querés que tu familia coma sano sin vivir en la cocina.'
  }, {
    icon: <WorkIcon sx={{
      fontSize: {
        xs: 28,
        md: 40
      }
    }} className="text-[#FF9F43]" data-id="element-136" />,
    text: 'Si sos profesional y tus almuerzos en el trabajo son un desastre.'
  }];
  return <section className="py-10 md:py-16 px-4 md:px-8 max-w-4xl mx-auto" data-id="element-137">
      <FadeIn data-id="element-138">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-8" data-id="element-139">
          ESTO ES PARA VOS SI...
        </h2>
      </FadeIn>

      <div className="space-y-2 md:space-y-4" data-id="element-140">
        {targets.map((target, index) => <FadeIn key={index} delay={0.1 * index} className="flex items-center bg-[#F5F5F5] p-4 md:p-8 rounded-2xl" data-id="element-141">
            <div className="bg-white p-3 md:p-4 rounded-full shadow-sm mr-4 md:mr-6 flex-shrink-0" data-id="element-142">
              {target.icon}
            </div>
            <p className="text-lg md:text-xl text-gray-800 font-medium" data-id="element-143">
              {target.text}
            </p>
          </FadeIn>)}
      </div>
    </section>;
}